exports.Tagger = require('./POSTagger');
exports.Lexer = require('./lexer');